import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { dollars } from "@/domains/library/format"

interface ZapGettingApprovalStatusProps {
  store: ZapStore
}

export const ZapGettingApprovalStatus = observer(({ store }: ZapGettingApprovalStatusProps) => {
  if (!store.estimate) return null
  if (!store.pool) return null

  return (
    <div className="text-t100 border-p400-light bg-p400 flex h-40 items-center justify-center rounded-lg border px-4 py-3 text-center">
      <div>
        <p className="text-t200 mb-1">You will receive</p>
        <p className="mb-2 text-4xl">{dollars(store.estimate.context.outputAmountUsd)}</p>
        <p className="text-t200 mb-1">{store.pool?.displayName}</p>
        <p className="text-t200 text-sm">{store.estimate.context.slippageTolerancePercentage.toFixed(2)}% slippage</p>
      </div>
    </div>
  )
})
